import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

const StyledVoiceCloneInput = styled('div')`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  padding: ${(props) => (props?.isMobile ? '24px' : '60px')};
  flex-direction: column;
  flex: 1;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  height: ${(props) => (props?.height ? `${props?.height}px` : '100vh')};
  background-color: ${COLOR.white};
  overflow-y: scroll;
  padding-bottom: 100px;
  gap: 32px;
`;

const Wrapper = styled('div')`
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
`;

export { StyledVoiceCloneInput, Wrapper };
